import { useState, Fragment } from 'react'
import { useTheme } from '@emotion/react'
import { dark, greenTeal } from 'chaoskit/src/assets/styles/utility/gradient'

import Image from '~components/Image'
import { VideoModal } from '~components/Video'
import Icon from '~components/Icon'

const KoltonVideo = () => {
  const theme = useTheme()

  const [videoModalOpen, setVideoModalOpen] = useState(false)

  return (
    <Fragment>
      <div
        css={{
          marginTop: theme.space.large,
          marginBottom: theme.space.large,

          [theme.mq.medium]: {
            display: 'grid',
            gridTemplateColumns: 'repeat(12, minmax(0, 1fr))',
            alignItems: 'start',
            marginBottom: theme.space.xlarge, // To account for transform
          },
        }}
      >
        <div
          className="u-contrast"
          css={{
            ...dark(theme),
            borderTopLeftRadius: theme.borderRadius.base,
            borderTopRightRadius: theme.borderRadius.base,
            padding: theme.space.large,

            [theme.mq.medium]: {
              borderBottomLeftRadius: theme.borderRadius.base,
              borderBottomRightRadius: theme.borderRadius.base,
              gridColumn: '1 / span 8',
              gridRow: 1,
            },
          }}
        >
          <div
            css={{
              [theme.mq.medium]: {
                display: 'grid',
                gridTemplateColumns: '0.65fr',
              },
            }}
          >
            <div css={{ ...theme.headingPreset.h4 }}>
              How many 9s are enough?
            </div>
            <p>
              Kolton Andrus, CEO of Gremlin, explains the real-world impact of
              availability in his talk on CTO Connection.
            </p>
          </div>
        </div>
        <div
          css={{
            alignSelf: 'end',

            [theme.mq.medium]: {
              gridColumn: '6 / span 7',
              gridRow: 1,
              transform: `translateY(${theme.space.large}px)`,
            },
          }}
        >
          {/* eslint-disable jsx-a11y/click-events-have-key-events */}
          <div
            css={{
              position: 'relative',
              cursor: 'pointer',
              boxShadow: theme.boxShadow.large,

              '&:hover, &:focus': {
                '.KoltonVideo__PlayButton': {
                  transform: 'translate(-50%, -50%) scale(1.125)',
                },
              },

              [theme.mq.medium]: {
                transform: `translateX(${theme.space.large}px)`,
              },
            }}
            tabIndex="-1"
            role="button"
            onClick={(e) => {
              // Used to help prevent bubbling the click to the parent link in the teaser view
              e.stopPropagation()

              setVideoModalOpen(true)
            }}
          >
            <div
              className="KoltonVideo__PlayButton"
              css={{
                ...greenTeal(theme),
                width: theme.height.large,
                height: theme.height.large,
                borderRadius: theme.borderRadius.rounded,
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                transition: `transform ${theme.timing.base} ${theme.transition.bounce}`,
                transformOrigin: 'center center',

                [theme.mq.medium]: {
                  left: 0,
                },
              }}
            >
              <Icon
                icon="play"
                css={{
                  fill: theme.contrast.base,
                  fontSize: theme.fontSize.xlarge,
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                }}
              />
            </div>
            <Image
              src="https://res.cloudinary.com/gremlin/image/upload/v1617397185/Reliability/kolton-screen.png"
              width="600"
              height="338"
              css={{
                borderBottomLeftRadius: theme.borderRadius.base,
                borderBottomRightRadius: theme.borderRadius.base,

                [theme.mq.medium]: {
                  borderTopLeftRadius: theme.borderRadius.base,
                  borderTopRightRadius: theme.borderRadius.base,
                },
              }}
            />
          </div>
        </div>
      </div>
      <VideoModal
        open={videoModalOpen}
        setIsOpen={setVideoModalOpen}
        title="How many 9s are enough?"
        src="https://www.youtube.com/embed/iN2x8yGoE10?modestbranding=1&rel=0&showinfo=0&autohide=1&autoplay=1"
      />
    </Fragment>
  )
}

export default KoltonVideo
